import styles from './UnauthorizedPage.module.css'

/**
 * Shown when a session has no customer it may access: an authenticated user who is neither
 * a `regard_admin` nor carries a customer claim, or one whose customer-scoped request was
 * rejected with a server-enforced 403.
 *
 * Shell-owned rather than an app's: `Bootstrap` and `CareGapsLayout` both redirect here,
 * and a session with no entitlement has no app to render it.
 */
export const UnauthorizedPage = () => (
  <main className={styles.container}>
    <div className={styles.card}>
      <h1 className={styles.heading}>No access</h1>
      <p className={styles.message}>
        Your account isn’t linked to a hospital you can view. Contact Regard
        support if you think this is a mistake.
      </p>
    </div>
  </main>
)
